export function toolTip(args) {
    args.className = args.className || "tip-twitter";
    args.liveEvents = args.liveEvents || true;
    args.allowTipHover = args.allowTipHover || false;
    args.showTimeout = args.showTimeout || 1;
    args.fade = args.fade || false;
    args.slide = args.slide || false;
    args.alignTo = args.alignTo === undefined ? "target" : args.alignTo;
    args.alignX = args.alignX === undefined ? "center" : args.alignX;
    args.offsetX = args.offsetX || 0;
    args.offsetY = args.offsetY || 5;

    if (args.destroy) {
        $(args.selector).poshytip("destroy");
    } else if (args.disable) {
        $(args.selector).poshytip("disable");
    } else if (args.enable) {
        $(args.selector).poshytip("enable");
    } else {
        $(args.selector).poshytip && $(args.selector).poshytip(args);
    }
}
